import { useState } from 'react'

const useSelectedParcels = ({ parcels }) => {
  const [selectedParcels, setSelectedParcels] = useState([])

  const selectParcel = id => {
    const parcel = parcels.find(parcel => parcel.id === id)

    if (selectedParcels.map(parcel => parcel.id).includes(id)) {
      setSelectedParcels(selectedParcels.filter(parcel => parcel.id !== id))
    } else {
      setSelectedParcels([...selectedParcels, parcel])
    }
  }

  const selectAll = event => {
    if (event.target.checked) {
      setSelectedParcels(parcels)
    } else {
      setSelectedParcels([])
    }
  }

  return {
    selectedParcels,
    setSelectedParcels,
    selectParcel,
    selectAll,
  }
}

export default useSelectedParcels
